<!--
 * @Author: TinaHuang0183 
 * @Date: 2022-07-22 18:28:08
 * @LastEditors: Tina Huang
 * @LastEditTime: 2023-03-02 13:10:28
 * @FilePath: /notion-widgets-site/src/components/create-aside/set-17.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-form-item label="起始" v-if="item.hasOwnProperty('monday')">
      <el-radio-group v-model="form.monday" size="medium">
        <el-radio border :label="1">周一</el-radio>
        <el-radio border :label="0">周日</el-radio>
      </el-radio-group>
    </el-form-item>
    <!-- 极简倒数日 -->
    <template v-if="item.id === 24">
      <el-form-item label="事件">
        <el-input
          v-model="form.name"
          width="200"
          placeholder="事件名称不超过5个字"
        ></el-input>
      </el-form-item>
      <el-form-item label="日期">
        <el-date-picker
          v-model="form.day"
          type="date"
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
    </template>
    <!-- 限定周 -->
    <template v-if="item.id === 15">
      <el-form-item label="说明：">
        <strong>不选择周区间</strong>则默认显示当前周（根据当前时间实时更新）
      </el-form-item>
      <el-form-item label="选择周">
        <el-date-picker
          v-model="form.day"
          type="week"
          format="yyyy第WW周"
          value-format="yyyy/MM/dd"
          placeholder="选择周"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
    </template>
    <!-- 人生进度条 -->
    <template v-if="item.id === 13">
      <el-form-item label="生日">
        <el-date-picker
          v-model="form.day"
          type="date"
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="昵称">
        <el-input
          v-model="form.name"
          width="200"
          placeholder="目标名称不超过5个字"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注文案">
        <el-input
          v-model="form.msg"
          width="200"
          placeholder="备注文案不超过12个字"
        ></el-input>
      </el-form-item>
    </template>
    <!-- 多项倒数日 -->
    <template v-if="item.id === 11 || item.id === 33">
      <el-form-item
        :label="`目标${index + 1}`"
        v-for="(item, index) in form.tasks"
        :key="`task-${index}`"
      >
        <el-input
          v-model="item.name"
          placeholder="目标名称不超过5个字"
          style="width: 200px; margin-right: 20px"
        ></el-input>
        <el-date-picker
          v-model="item.day"
          type="date"
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <el-button
          icon="el-icon-plus"
          circle
          size="small"
          v-show="index === 0 && form.tasks.length < 4"
          @click="onAddItem(index, 1)"
        ></el-button>
        <el-button
          icon="el-icon-delete"
          circle
          size="small"
          v-show="index > 0"
          style="margin: 0"
          @click="onAddItem(index, -1)"
        ></el-button>
      </el-form-item>
    </template>
    <!-- 引用快 -->
    <template v-if="item.id >= 1001 && item.id < 1002">
      <el-form-item label="文案">
        <el-input
          v-model="form.content"
          width="200"
          placeholder="这里是文案"
        ></el-input>
      </el-form-item>
    </template>
    <!-- 卡片倒数日 -->
    <template v-if="item.id === 27 || item.id === 28 || item.id === 32">
      <el-form-item label="事件">
        <el-input
          v-model="form.name"
          width="200"
          placeholder="事件名称不超过5个字"
        ></el-input>
      </el-form-item>
      <el-form-item label="目标日">
        <el-date-picker
          v-model="form.day"
          type="date"
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
    </template>
    <!-- 范围日期 -->
    <template v-if="item.id === 29">
      <el-form-item label="高亮颜色">
        <el-color-picker v-model="form.highlight"></el-color-picker>
      </el-form-item>
      <el-form-item label="日期范围">
        <el-date-picker
          v-model="form.date_range"
          type="daterange"
          align="right"
          unlink-panels
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions2"
        >
        </el-date-picker>
      </el-form-item>
    </template>
    <!-- 发光时钟 -->
    <template v-if="item.id === 30">
      <el-form-item label="语言">
        <el-select v-model="form.lan" placeholder="请选择">
          <el-option key="cn" label="中文" value="cn"></el-option>
          <el-option key="en" label="英文" value="en"> </el-option>
        </el-select>
      </el-form-item>
    </template>
    <!-- 模版按钮 -->
    <template v-if="item.id === 1004">
      <el-form-item label="文案">
        <el-input
          v-model="form.btn_name"
          width="50"
          placeholder="按钮文案"
        ></el-input>
      </el-form-item>
      <el-form-item label="目标链接">
        <el-input
          v-model="form.link"
          width="50"
          placeholder="请输入目标链接"
        ></el-input>
      </el-form-item>
      <el-form-item label="尺寸">
        <el-radio-group v-model="form.size">
          <el-radio label="normal">默认</el-radio>
          <el-radio label="large">较大</el-radio>
        </el-radio-group>
      </el-form-item>
    </template>
    <!-- 区间进度条 -->
    <template v-if="item.id === 31">
      <el-form-item label="事项名称">
        <el-input
          v-model="form.name"
          width="200"
          placeholder="事件名称不超过5个字"
        ></el-input>
      </el-form-item>
      <el-form-item label="日期范围">
        <el-date-picker
          v-model="form.date_range"
          type="daterange"
          align="right"
          unlink-panels
          format="yyyy/MM/dd"
          value-format="yyyy/MM/dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </template>
    <!-- 倒数卡片 -->
    <template v-if="item.id === 32">
      
    </template>
  </div>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      form: {
        monday: 1,
        tasks: [{ day: "2022/12/31", name: "2022结束" }],
        name: "",
        day: "",
        content: "这里是自定义文案 · Here is the custom text",
        highlight: "#77ac98",
        date_range: "",
        lan: "cn",
        btn_name: "Github",
        size: "normal",
        link: "",
      },
    };
  },
  computed: {
    pickerOptions: function () {
      return {
        firstDayOfWeek: this.form.monday ? 1 : 7,
      };
    },
    pickerOptions2: function () {
      return {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      };
    },
  },
  mounted() {
    console.log(this.item);
    let cur_date = new Date();
    this.form.created = `${cur_date.getFullYear()}/${
      cur_date.getMonth() + 1
    }/${cur_date.getDate()}`;
  },
  methods: {
    onAddItem(index, action) {
      if (action > 0) {
        this.form.tasks.push({
          name: `目标名称${this.form.tasks.length}`,
          day: "2022/12/31",
        });
      } else {
        let _tasks = JSON.parse(JSON.stringify(this.form.tasks))
        _tasks.splice(index, 1)
        this.form.tasks = _tasks
      }
    },
  },
  watch: {
    form: {
      handler(newV) {
        this.$emit("on-form", newV);
      },
      deep: true,
    },
  },
};
</script>
